<template>
  <div class="p-2">
    <!-- by year -->
    <b-card header="">
      <b-row class="animated fadeIn" align-h="center">
        <b-col sm="3">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text >
                <strong>Select year</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-select id="year-select" @change="getPilgrimsByYear" :options="years" v-model="year"  />
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="pt-4">
        <b-col sm="">
          <Callout variant="success">
              <h6 class="font-weight-bold">Completed registration</h6><br>
              <strong class="h2">{{complete}} </strong>
          </Callout>
        </b-col>
          <!-- incompleted regs -->
        <b-col sm="">
          <Callout variant="warning">
              <h6 class="font-weight-bold">Incompleted Registration</h6><br>
              <strong class="h2">{{incomplete}} </strong>
          </Callout>
        </b-col>
        <b-col sm="">
          <Callout variant="info">
              <h6 class="font-weight-bold">Payment received</h6><br>
              <strong class="h2">{{formatToBDT(this.payment)}} </strong>
          </Callout>
        </b-col>
        <b-col sm="2">
          <Callout variant="dark">
              <h6 class="font-weight-bold">Male</h6><br>
              <strong class="h2">{{maleCount}} </strong>
          </Callout>
        </b-col>
        <b-col sm="2">
          <Callout variant="dark">
              <h6 class="font-weight-bold">Female</h6><br>
              <strong class="h2">{{femaleCount}} </strong>
          </Callout>
        </b-col>
      </b-row>
    </b-card>
    <!-- by month -->
    <b-card header="" v-if='year'>
      <b-row class="animated fadeIn" align-h="center">
        <b-col sm="3">
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text >
                <strong>Select Month</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-select id="year-select" @change="getPilgrimsByMonth" :options="months" v-model="month"  />
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="pt-4">
        <b-col sm="">
          <Callout variant="success">
              <h6 class="font-weight-bold">Completed registration</h6><br>
              <strong class="h2">{{mComplete}} </strong>
          </Callout>
        </b-col>
          <!-- incompleted regs -->
        <b-col sm="">
          <Callout variant="warning">
              <h6 class="font-weight-bold">Incompleted Registration</h6><br>
              <strong class="h2">{{mIncomplete}} </strong>
          </Callout>
        </b-col>
        <b-col sm="">
          <Callout variant="info">
              <h6 class="font-weight-bold">Payment received</h6><br>
              <strong class="h2">{{formatToBDT(mPayment)}} </strong>
          </Callout>
        </b-col>
        <b-col sm="2">
          <Callout variant="dark">
              <h6 class="font-weight-bold">Male</h6><br>
              <strong class="h2">{{mMaleCount}} </strong>
          </Callout>
        </b-col>
        <b-col sm="2">
          <Callout variant="dark">
              <h6 class="font-weight-bold">Female</h6><br>
              <strong class="h2">{{mFemaleCount}} </strong>
          </Callout>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>    

<script>
import { Callout } from '@coreui/vue'
import VueNotifications from 'vue-notifications'
import axios from 'axios'

export default {
  name: 'statistics',
  components: {
    Callout
  },
  created(){
    this.getStatsDataset()
  },
  updated(){

  },
  data() {
    return {
      //for year
      complete:0,
      incomplete:0,
      payment:0,
      maleCount:0,
      femaleCount:0,
      //for monthly
      mComplete:0,
      mIncomplete:0,
      mPayment:0,
      mMaleCount:0,
      mFemaleCount:0,

      dataset:[],
      year: null,
      month:null,
      years:[],
      months:[
        {text:'January', value:'Jan'},
        {text:'February', value:'Feb'},
        {text:'March', value:'Mar'},
        {text:'April', value:'Apr'},
        {text:'May', value:'May'},
        {text:'June', value:'Jun'},
        {text:'July', value:'July'},
        {text:'August', value:'Aug'},
        {text:'September', value:'Sep'},
        {text:'October', value:'Oct'},
        {text:'November', value:'Nov'},
        {text:'December', value:'Dec'}
      ]

    }
  },
  methods: {
    formatToBDT(val){
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'BDT' }).format(val);
    },
    completedRegs(month=null){
      if(!month){
        this.complete = 0, this.incomplete =0;
        this.dataset.forEach((elm, it)=>{
          if (elm.registration.status == 'Complete'){
            this.complete++;
          }
          else{
            this.incomplete++;
          }
        })
      }
      else{
        this.mComplete = 0, this.mIncomplete =0;
        this.dataset.forEach((elm, it)=>{
          if(elm.registration.date.search(month) > -1){
            if (elm.registration.status == 'Complete'){
              this.mComplete++;
            }
            else{
              this.mIncomplete++;
            }
          }
        })
      }
    },
    paymentReceived(month=null){
      if(!month){
        this.payment=0;
        this.dataset.forEach((elm, it)=>{
          this.payment += elm.payment.paid;
        })
      }
      else{
        this.mPayment=0;
        this.dataset.forEach((elm, it)=>{
          if(elm.registration.date.search(month) > -1){
            this.mPayment += elm.payment.paid;
          }
        })
      }
    },
    hazz(month=null){
      this.mMaleCount=0;
      this.mFemaleCount=0; 
      if(!month){
        this.maleCount=0; this.femaleCount=0;
        this.dataset.forEach((elm, it)=>{
          if(elm.gender =='Male'){
            this.maleCount++;
          }
          else{
            this.femaleCount++;
          }
        })
      }
      else{
        this.mMaleCount=0;this.mFemaleCount=0; 
        this.dataset.forEach((elm, it)=>{
          if(elm.registration.date.search(month) > -1){
            if(elm.gender =='Male'){
              this.mMaleCount++;
            }
            else{
              this.mFemaleCount++;
            }
          }
        })
      }
    }, 
    getYearForFilter(){
      // return axios.get( `http://192.168.100.107:8080/pilgrimDB/pilgrimTable.php`,{
      return axios.get(`pilgrimDB/pilgrimTable.php`,{
      params:{ years:"yes" },  withCredentials: true
      })
      .then(response => {
        response.data.forEach( (elm, it, arr) => {
          this.years.push(elm['year']);
        });
      })
      .catch(error => {
        if(!error.response){
          this.showErrorMsg({title:"Network Error!!"})
        }
        else{
          this.showErrorMsg({title:error.response})
        }
        console.log(error);
      });
    },
    getPilgrimsByYear(year){
      // return axios.get(`http://192.168.100.107:8080/pilgrimDB/pilgrimTable.php`,{
      return axios.get(`pilgrimDB/pilgrimTable.php`,{
      params:{ filter:year},  withCredentials: true
      })
      .then(response => {
        this.dataset = [];
        response.data.forEach( (elm, it, arr) => {
          this.dataset.push(JSON.parse(elm['information']));
        });
      })
      .catch(error => {
        if(!error.response){
          this.showErrorMsg({title:"Network Error!!"})
        }
        else{
          this.showErrorMsg({title:error.response})
        }
          console.log(error);
      })
      .then(()=>{
          this.completedRegs();
          this.paymentReceived();
          this.hazz();
          this.month=null;
          // this.omrah();
      }
      );
    },
    getPilgrimsByMonth(month){
      this.completedRegs(month);
      this.paymentReceived(month);
      this.hazz(month);
    },
    getStatsDataset(){
      this.getYearForFilter()
      .then(() =>{
        this.year = this.years[0];
        this.getPilgrimsByYear(this.year)
     
      })
      
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      message: '',
      position: "topRight",
      timeout: 5000
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: '',
      message: '',
      position: "topRight",
      timeout: 5000

    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: '',
      message: '',
      position: "topRight",
      timeout: 10000

    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      message: '',
      position: "topRight",
      timeout: 10000
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>